var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-notransform",attrs:{"outlined":"","small":"","color":"secondary"},on:{"click":function($event){return _vm.toMenu()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-chevron-left")]),_c('span',[_vm._v("Back to Menu")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }